import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {
  List,
  Datagrid,
  EditButton,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Filter,
  BulkDeleteButton,
  Toolbar,
  SaveButton,
  DeleteButton,
  required,
  TextField,
  usePermissions,
  useRecordContext,
  ListButton,
  ReferenceField,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

const CaracteristicasTitle = () => {
  const record = useRecordContext();
  if (!record) return null;

  return <span>Descrição da Característica {record.name}</span>;
};

const CaracteristicasFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Procurar" source="q" alwaysOn />
  </Filter>
);

const PostBulkActionButtons = ({ permissions, ...props }) => (
  <>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_CARACTERISTICAS_DELETE')) && (
        <BulkDeleteButton {...props} />
      )}
  </>
);

export const DescricaoCaracteristicas = (props) => {
  const permissions = usePermissions();

  return (
    <List
      perPage={25}
      title="Caracteristicas"
      filters={<CaracteristicasFilter />}
      sort={{ field: 'id', order: 'DESC' }}
      {...props}
    >
      <Datagrid
        bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      >
        <TextField label="Descrição" source="description" />
        <ReferenceField
          label="Característica"
          source="characteristic"
          reference="characteristics"
        >
          <TextField source="name" />
        </ReferenceField>
        {!permissions.isLoading &&
          (permissions.permissions.includes('SYS_ADMIN') ||
            permissions.permissions.includes(
              'ROLE_CARACTERISTICAS_UPDATE',
            )) && <EditButton />}
      </Datagrid>
    </List>
  );
};

const CustomToolbar = ({ permissions, ...props }) => (
  <Toolbar
    {...props}
    className="botoesUpdate"
    style={{ justifyContent: 'space-between' }}
  >
    <div
      style={{
        width: '250px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <SaveButton alwaysEnable />
      <ListButton
        size="medium"
        variant="outlined"
        label="cancelar"
        icon={<CloseIcon />}
      />
    </div>
    {!permissions.isLoading &&
      (permissions.permissions.includes('SYS_ADMIN') ||
        permissions.permissions.includes('ROLE_CARACTERISTICAS_DELETE')) && (
        <DeleteButton size="medium" />
      )}
  </Toolbar>
);

export const DescricaoCaracteristicasEdit = (props) => {
  const permissions = usePermissions();

  return (
    <Edit redirect="list" title={<CaracteristicasTitle />} {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <ReferenceInput
          label="Característica"
          source="characteristic"
          reference="characteristics"
          validate={required()}
        >
          <SelectInput
            validate={required()}
            label="Característica"
            fullWidth
            optionText="name"
          />
        </ReferenceInput>
        <TextInput
          label="Descrição"
          fullWidth
          source="description"
          validate={required()}
        />
      </SimpleForm>
    </Edit>
  );
};

export const DescricaoCaracteristicasCreate = (props) => {
  const permissions = usePermissions();

  return (
    <Create redirect="list" {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <ReferenceInput
          label="Característica"
          source="characteristic"
          reference="characteristics"
          validate={required()}
        >
          <SelectInput
            validate={required()}
            label="Característica"
            fullWidth
            optionText="name"
          />
        </ReferenceInput>
        <TextInput
          label="Descrição"
          fullWidth
          source="description"
          validate={required()}
        />
      </SimpleForm>
    </Create>
  );
};

export default DescricaoCaracteristicas;
